import React from "react";
import { Match } from "found";

import { AdminPanelViews } from "../AdminPanel.container";
import { AdminPanelOverviewContainer } from "./admin-panel-overview";
import { AdminPanelBillingGroupsMembersContainer } from "./admin-panel-billing-groups-members";
import { AdminPanelBillingGroupsPlansAndBillingContainer } from "./admin-panel-billing-groups-plans-and-billing";
import { AdminPanelSettingsContainer } from "./admin-panel-settings";

interface IAdminPanelViewProps {
  match: Match;
  currentView: AdminPanelViews;
  orgRelayId: string;
  primaryBillingGroupId?: string;
}

export const AdminPanelView = (props: IAdminPanelViewProps) => {
  const { currentView, orgRelayId, primaryBillingGroupId } = props;

  if (currentView === AdminPanelViews.Overview) {
    return <AdminPanelOverviewContainer orgRelayId={orgRelayId} />;
  }

  if (currentView === AdminPanelViews.Members) {
    return (
      <AdminPanelBillingGroupsMembersContainer
        orgRelayId={orgRelayId}
        match={props.match}
        primaryBillingGroupId={primaryBillingGroupId}
      />
    );
  }

  if (currentView === AdminPanelViews.PlansAndBilling) {
    return <AdminPanelBillingGroupsPlansAndBillingContainer orgRelayId={orgRelayId} />;
  }

  if (currentView === AdminPanelViews.Settings) {
    return <AdminPanelSettingsContainer orgRelayId={orgRelayId} />;
  }

  return null;
};
